import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const GLOBAL_HEADERS = {
  headers: new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Ocp-Apim-Subscription-Key', environment.apimSubscriptionKey),
};
